import BlogPost from "../components/BlogPost";

export default function Post() {
  return <BlogPost />;
}